// removed by extract-text-webpack-plugin
module.exports = {"accountSettingsModalOverlay":"_1PoNN","accountSettingsModal":"_35z5g","fadeIn":"_1p0lx","closing":"_1of5t","fadeOut":"_15kYV","banquetLogo":"_3bOce","closeButton":"_1LGcl"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AccountSettingsModal/index.sass
// module id = 1454
// module chunks = 1